"use strict";
/**
 * SWR Step Types — Single Source of Truth.
 *
 * sl-8zjk: Previously duplicated across three files with "byte-compatible"
 * mirror comments (runner/domain/types/step-type.ts, server/interfaces/
 * automation/runner-input-contract.ts, server/config/limits.config.ts) plus
 * frontend/workflow-viewer/types/swr-definitions.ts and
 * runner/domain/plan-defaults.ts. Drift already occurred twice (`join` missing
 * in limits.config pre-sl-g3on audit; `media` missing in three+ places during
 * sl-oe5x.3.3). This module is now the canonical definition — all other
 * locations re-export from here so drift is architecturally impossible.
 *
 * Categories:
 * - Compute: ai, code, http, service, media (execute logic)
 * - Control: branch_or, branch_xor, branch_and, merge (routing)
 * - Loop: loop (unified with mode selector: counter, condition, array)
 * - Transform: split, filter, join, output_sanitizer, json_extract (data operations)
 * - Interface: start, end (workflow I/O boundaries)
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WORKFLOW_PREVIEW_SAFE_STEP_TYPES = exports.STEP_TYPES = exports.LOOP_PORTS = exports.LOOP_EXIT_PORT = exports.LOOP_CONTINUE_PORT = void 0;
exports.isValidStepType = isValidStepType;
exports.isWorkflowPreviewSafeStepType = isWorkflowPreviewSafeStepType;
/**
 * sl-tj3g: Loop output port constants.
 * Loop has 2 explicit output ports:
 * - CONTINUE: Loop body (true path — condition met, iterate again)
 * - EXIT: Main flow continues (false path — condition no longer met)
 */
exports.LOOP_CONTINUE_PORT = 'continue';
exports.LOOP_EXIT_PORT = 'exit';
exports.LOOP_PORTS = [exports.LOOP_CONTINUE_PORT, exports.LOOP_EXIT_PORT];
/** Runtime check: all valid step type values. */
exports.STEP_TYPES = [
    'ai',
    'code',
    'http',
    'service',
    'media',
    'branch_or',
    'branch_xor',
    'branch_and',
    'merge',
    'loop',
    'split',
    'filter',
    'join',
    'output_sanitizer',
    'json_extract',
    'start',
    'end',
];
/**
 * Step types that a Workflow Builder preview may execute without explicit
 * user consent because they do not call external providers or mutate outside
 * state. Compute/service steps stay opt-in per preview request.
 */
exports.WORKFLOW_PREVIEW_SAFE_STEP_TYPES = [
    'start',
    'end',
    'branch_or',
    'branch_xor',
    'branch_and',
    'merge',
    'loop',
    'split',
    'filter',
    'join',
    'output_sanitizer',
    'json_extract',
];
/** Check if a string is a valid StepType. */
function isValidStepType(value) {
    return exports.STEP_TYPES.includes(value);
}
/** Check if a step type is safe for side-effect-free workflow preview. */
function isWorkflowPreviewSafeStepType(value) {
    return exports.WORKFLOW_PREVIEW_SAFE_STEP_TYPES.includes(value);
}
